module.exports = __webpack_public_path__ + "static/media/leadx_logo.cc8d8ae1.png";